import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'add-strategy',
  templateUrl: './add-strategy.component.html',
  styleUrls: ['./add-strategy.component.scss']
})
export class AddStrategyComponent {
  public addStrategyForm: FormGroup;
  @ViewChild('standardStrategy') private standardStrategy: TemplateRef<any>;
  @Output() onClose = new EventEmitter<string>();

  constructor(private dialog: MatDialog) { }

  showPopup() {
    this.dialog.open(this.standardStrategy, { width: '700px', height: '350px', panelClass: 'option-dialog' })
    this.addStrategyForm = new FormGroup({
      StrategyName: new FormControl('', [Validators.required, Validators.minLength(1)]),
      value: new FormControl('', [Validators.required, Validators.minLength(1)])
    });
  }

  saveStrategy() {
    if (this.addStrategyForm.valid) {
      this.onClose.emit(this.addStrategyForm.value);
      this.dialog.closeAll();
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
